import { render, staticRenderFns } from "./EnacAtplDashboardPhaseLearners.vue?vue&type=template&id=ea6165a0"
import script from "./EnacAtplDashboardPhaseLearners.vue?vue&type=script&lang=js"
export * from "./EnacAtplDashboardPhaseLearners.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports